import { useContext, createContext, useEffect, useState } from 'react';

import { MenuItem } from '@lglp/prismic-client';
import { useLocation } from 'react-router';

const DesktopContext = createContext<DesktopContextProps | undefined>(
  undefined
);

export const useDesktopContext = (): DesktopContextProps => {
  const context = useContext(DesktopContext);
  if (!context) {
    throw new Error('useDesktopContext must be inside a DesktopLayout');
  }
  return context;
};

type DesktopContextProps = {
  isMenuOpen: (level: number, item: MenuItem) => boolean;
  close: () => void;
  openedMenus: MenuItem[];
  openMenu: (level: number, item: MenuItem) => void;
};

export const useInitializeContext = (): DesktopContextProps => {
  const [openedMenus, setOpenedMenus] = useState<MenuItem[]>([]);

  const location = useLocation();

  useEffect(() => {
    setOpenedMenus([]);
  }, [location]);

  const openMenu = (level: number, item: MenuItem) => {
    if (openedMenus[level]?.label === item.label) {
      return;
    }
    setOpenedMenus([
      ...openedMenus.filter((item, index) => index < level),
      item,
    ]);
  };

  const isMenuOpen = (level: number, item: MenuItem) => {
    return openedMenus[level]?.label === item.label;
  };

  const close = () => {
    setOpenedMenus([]);
  };

  return {
    isMenuOpen,
    close,
    openedMenus,
    openMenu,
  };
};

export default DesktopContext;
